import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect, useRef } from 'react';
import { getHebrewDayName, getHebrewMonth } from '../../../utilities/dateUtils';
import { isMobile } from 'react-device-detect';

const DateTimeSlots = ({ dateTimeList, selectedDay, selectedHours, setSelectedDay, setSelectedHours, maxItemToDisplay }) => {
    const [displayDates, setDisplayDates] = useState(dateTimeList);
    const [currentIndex, setCurrentIndex] = useState(0);


    useEffect(() => {
        if (!isMobile) {
            setDisplayDates(dateTimeList)
            var dateList = dateTimeList.slice(0, maxItemToDisplay)
            setDisplayDates(dateList);
        }
        if (!selectedDay) {
            setSelectedDay(displayDates[0]);
            setSelectedHours(displayDates[0].slots[0]);
        }
    }, []);


    const handlePrev = () => {
        if (currentIndex === 0) return;
        let prevIndex = currentIndex - 1;
        setCurrentIndex(prevIndex);
        setDisplayDates(dateTimeList.slice(prevIndex, maxItemToDisplay + prevIndex));
    }

    const handleNext = () => {
        if (currentIndex === dateTimeList.length - maxItemToDisplay - 1) return;
        let nextIndex = currentIndex + 1;
        setCurrentIndex(nextIndex);
        setDisplayDates(dateTimeList.slice(nextIndex, nextIndex + maxItemToDisplay));
    }



    return (
        <div className='date_time_container'>
            <div className='date_container' >
                <div className='swiper-date' >
                    <Image src={require('./icons/arrowRight.svg')} onClick={() => handlePrev()}
                        className={`arrow ${currentIndex === 0 ? 'disable' : ''}`} />
                    {displayDates?.map((dateSlot, index) => {
                        const hebrewDay = getHebrewDayName(dateSlot.date);
                        const hebrewMonthName = getHebrewMonth(dateSlot.date);
                        return (
                            <div key={index}
                                className={`date-slot ${dateSlot === selectedDay ? 'selected' : ''}`}
                                onClick={() => {
                                    setSelectedDay(dateSlot);
                                    setSelectedHours(dateSlot.slots[0]);
                                }}>
                                <div className='month-title'>{hebrewMonthName}</div>
                                <div className='date-number'>{dateSlot.date.split('-')[2]}</div>
                                <div className='date-title'> {hebrewDay}</div>
                            </div>
                        )
                    })}
                    <Image src={require('./icons/arrowLeft.svg')} onClick={() => handleNext()}
                        className={`arrow ${currentIndex === dateTimeList.length - maxItemToDisplay - 1 ? 'disable' : ''}`} />
                </div>

            </div>
            <div className='hour-slot-container'>
                {selectedDay && selectedDay.slots.map((slot, index) => {
                    return (
                        <div className={`hours-slot ${slot === selectedHours ? 'selected' : ''}`} onClick={() => setSelectedHours(slot)}>
                            בין {slot.startHour.substring(0, 5)} - {slot.endHour.substring(0, 5)}
                        </div>
                    )
                })}
            </div>
        </div>
    );
};

export default DateTimeSlots;
